export {default as ConfigSpiAuthorize} from './config-spi-authorize'
